export const ERROR = 'ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const RESPONSE_ERROR = 'RESPONSE_ERROR';

export const SUCCESS = 'SUCCESS';
export const SUCCESS_WITH_OPTIONS = 'SUCCESS_WITH_OPTIONS';
export const HIDE_SUCCESS = 'HIDE_SUCCESS';
export const RESPONSE_SUCCESS = 'RESPONSE_SUCCESS';